export default {
    apiKey: "AIzaSyDID8wQBuZCVAXZXWN3PoMidd_mKJkAH8M",
    authDomain: "starfinder-character-cre-2b9fc.firebaseapp.com",
    databaseURL: "https://starfinder-character-cre-2b9fc.firebaseio.com",
    projectId: "starfinder-character-cre-2b9fc",
    storageBucket: "starfinder-character-cre-2b9fc.appspot.com",
    messagingSenderId: "257636364437",
    appId: "1:257636364437:web:9fd01be19801a036dfeb9c",
  };